import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import { mobileApp } from "../../../../config/config";
//import { Link } from "react-router";
import { Modal } from "react-bootstrap";
import Embed from "../components/FluidEmbed";
import assign from "object-assign";

let App = React.createClass({
    componentWillMount() {
        if (!Marty.isServer && this.app.router.getCurrentPathname() === "/app") {
            const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            const android = navigator.userAgent.toLowerCase().indexOf("android") > -1;

            if (iOS) {
                window.location = mobileApp.ios;
            } else if (android) {
                window.location = mobileApp.android;
            }
        }
    },
    closeModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: false}
            )
        });
    },
    openModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: true}
            )
        });
    },
    render() {
        return (
            <section className="eo-view app grid-10 parent">
                <Hero>
                    <h1>First things first</h1>

                    <h2>Download the app to set up your eero system</h2>
                    <img className="phones" src="/public/img/app/phones.png"/>

                    <div className="store-badges">
                        <a href={mobileApp.ios} className="badge ios" target="_blank">
                            <img alt="Download on the App Store" src="/public/img/app/badge_apple.svg"/>
                        </a>
                        <a href={mobileApp.android} className="badge android" target="_blank">
                            <img alt="Get it on Google Play" src="/public/img/app/badge_google.png"/>
                        </a>
                    </div>
                </Hero>
                <section className="grid-10 eo-section eo-info-panel centered requirements">
                    <h2 className="eo-info-panel-header grid-10">Setup requirements</h2>

                    <div className="grid-5  grid-s-10 req-group in-the-box">
                        <div className="grid-5 grid-s-10 group-img">
                            <img src="/public/img/app/in-the-box.png" className="eo-img-fluid"/>
                        </div>
                        <div className="grid-5 grid-s-10">
                            <h4 className="setup-header"><strong>In the box</strong></h4>
                            <ul className="req-list">
                                <li className="req-list-item">eero(s)</li>
                                <li className="req-list-item">Power cord(s)</li>
                                <li className="req-list-item">Ethernet cable</li>
                            </ul>
                        </div>
                    </div>
                    <div className="grid-5 grid-s-10 req-group what-you-need">
                        <div className="grid-4 grid-s-10 group-img">
                            <img src="/public/img/root/img-features-dashboard.png" className="eo-img-fluid"/>
                        </div>
                        <div className="grid-6 grid-s-10">
                            <h4 className="setup-header"><strong>What you'll need</strong></h4>
                            <ul className="req-list">
                                <li className="req-list-item"><a className="eo-link" href="https://support.eero.com/hc/en-us/articles/207852793-Which-mobile-devices-can-I-use-to-set-up-and-manage-my-eeros-" target="_blank">Supported iOS or Android™ device with data connection</a></li>
                                <li className="req-list-item">Active internet connection from an Internet Service Provider (ISP)</li>
                                <li className="req-list-item">Depending on your ISP this may or may not require a modem</li>
                            </ul>
                        </div>
                    </div>
                    <div className="setup-video">
                        <div className="play-video" onClick={this.openModal.bind(this, "video")}>
                            <button className="btn-play"
                                    onClick={this.openModal.bind(this, "video")}>
                                <span className="btn-play-icon icon eo-icon-play"/>
                            </button>
                            <span className="play-copy eo-link">Watch setup video</span>
                        </div>
                    </div>
                    <Modal dialogClassName="eo-modal video-modal" show={this.state.showModal.video}
                           onHide={this.closeModal.bind(this, "video")}>
                        <Modal.Header closeButton/>
                        <Modal.Body>
                            <Embed src="https://www.youtube.com/embed/YysjcLqinHs"/>
                        </Modal.Body>
                    </Modal>
                </section>
                {/*<Link to="support" className="help-link grid-10"><span className="help-copy">Need help getting started? Watch our setup video</span><span className="icon eo-icon-arrow-right"/></Link>*/}
                {/*<section className="grid-10 eo-cta places hide-s">
                    <div className="eo-cta-content float-right">
                        <h2 className="eo-cta-header">OH, THE PLACES<br/>YOU'LL STREAM</h2>
                        <Link className="eo-btn-outline blue hover-blue" to="technology">Learn about</Link>
                    </div>
                </section>*/}
            </section>
        );
    },
    getInitialState() {
        return {
            showModal: {
                video: false
            }
        };
    }
});

export default Marty.createContainer(App, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/app/Handler.js
 **/